import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.css']
})
export class CareersComponent implements AfterViewInit, OnInit {
  careersForm: FormGroup;
  isSubmitted = false;
  cv_pdf : any
  isAPIExecute : any = false

  constructor(public shared: SharedService, private apiService: ApiServiceService, private fb: FormBuilder, private router: Router) {
    this.careersForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      subject: ['', Validators.required],
      attach_your_cv: ['', Validators.required],
    });
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  handleFileChange(event : any) {
    this.cv_pdf = [...event.target.files];
}



  async onDone() {
    if (this.careersForm.valid) {
      const formData = new FormData();
      let files : any = this.cv_pdf
      formData.append("name", this.careersForm.value.name);
      formData.append("email", this.careersForm.value.email);
      formData.append("mobile", this.careersForm.value.mobile);
      formData.append("subject", this.careersForm.value.subject);
      formData.append("files", this.cv_pdf);
      for (let t of files) {
        formData.append("files", t);
      }
      this.apiService.isUploadImage = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_CAREER, formData)
      if (res && !res.error) {
        this.isAPIExecute = true
      }
    }
  }
}
